import { createFileRoute } from '@tanstack/react-router'

import { InvoicesPage } from '#/modules/subscriptions/invoices-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/subscription-invoices')({
  component: InvoicesPage,
  validateSearch: validateListSearch,
})
